import styles from './Header.module.scss'
export default function Header({ children, texts }) {
	return (
		<div className={styles.container}>
			<div>
				<p className={styles.titol}>{texts.title}</p>
				<p className={styles.subtitol}>{texts.subtitle}</p>
			</div>
			{children}
		</div>
	)
}
